import React from "react";
import PropTypes from "prop-types";
import { Transition, Segment, Table, Popup, Button } from "semantic-ui-react";
import _ from "lodash";
import shortid from "shortid";
import ModalComentarios from "../../../pages/shared/ModalComentarios";

class TablaIncidencias extends React.Component {
  state = {
    column: null,
    data: this.props.datos,
    direction: null
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ data: nextProps.datos });
  }

  handleClick = (tipo, incidencia, texto) => {
    if (_.isEmpty(texto)) {
      alert("No hay texto");
      return;
    }

    switch (tipo) {
      case "cerrar":
        this.props.cerrarIncidencia(incidencia);
        break;

      case "guardar":
        this.props.guardarIncidencia(incidencia, texto);
        break;

      default:
        break;
    }
  };

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <Transition.Group animation="scale" duration={250}>
        {!_.isEmpty(this.props.datos) && (
          <Segment>
            <Table sortable striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell
                    collapsing
                    sorted={column === "cerrada" ? direction : null}
                    onClick={this.handleSort("cerrada")}
                    content="Estado"
                  />
                  <Table.HeaderCell
                    collapsing
                    sorted={column === "nombreAlumno" ? direction : null}
                    onClick={this.handleSort("nombreAlumno")}
                    content="Nombre"
                  />
                  <Table.HeaderCell
                    collapsing
                    sorted={column === "apellidosAlumno" ? direction : null}
                    onClick={this.handleSort("apellidosAlumno")}
                    content="Apellidos"
                  />
                  <Table.HeaderCell
                    sorted={column === "comentario" ? direction : null}
                    onClick={this.handleSort("comentario")}
                    content="Comentario"
                  />
                  <Table.HeaderCell
                    sorted={column === "fecha" ? direction : null}
                    onClick={this.handleSort("fecha")}
                    content="Fecha Creación"
                  />
                  <Table.HeaderCell
                    sorted={column === "fechaCierre" ? direction : null}
                    onClick={this.handleSort("fechaCierre")}
                    content="Fecha Cierre"
                  />
                  <Table.HeaderCell collapsing content="Cerrar" />
                  <Table.HeaderCell collapsing content="Editar" />
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {_.map(data, d => (
                  <Table.Row key={shortid.generate()}>
                    <Table.Cell
                      textAlign="center"
                      icon={d.cerrada ? "checkmark" : "cancel"}
                    />
                    <Table.Cell collapsing content={d.nombreAlumno} />
                    <Table.Cell collapsing content={d.apellidosAlumno} />
                    <Table.Cell content={d.comentario} />
                    <Table.Cell
                      collapsing
                      textAlign="center"
                      content={new Date(
                        parseInt(d.fecha, 10)
                      ).toLocaleDateString()}
                    />
                    <Table.Cell
                      collapsing
                      textAlign="center"
                      content={
                        !_.isEmpty(d.fechaCierre) &&
                        new Date(
                          parseInt(d.fechaCierre, 10)
                        ).toLocaleDateString()
                      }
                    />
                    <Table.Cell>
                      <Popup
                        trigger={
                          <Button
                            disabled={d.cerrada}
                            circular
                            color="green"
                            icon="check"
                            onClick={() => this.handleClick("cerrar", d)}
                          />
                        }
                        content="Cerrar Incidencia"
                        basic
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Popup
                        trigger={
                          <ModalComentarios
                            disabled={d.cerrada}
                            headerText={`Incidencia de ${d.nombreAlumno}`}
                            color="grey"
                            content={d.comentario || null}
                            itemID={d.id}
                            onSave={(id, texto) =>
                              this.handleClick("guardar", d, texto)
                            }
                            icon="pencil"
                          />
                        }
                        content="Editar Incidencia"
                        basic
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Segment>
        )}
      </Transition.Group>
    );
  }
}

TablaIncidencias.propTypes = {
  datos: PropTypes.array.isRequired
};

export default TablaIncidencias;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoIncidencias/TablaIncidencias.jsx